import { render, staticRenderFns } from "./IntroducingCoroot.vue?vue&type=template&id=8fe5f39e&scoped=true"
import script from "./IntroducingCoroot.vue?vue&type=script&lang=js"
export * from "./IntroducingCoroot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe5f39e",
  null
  
)

export default component.exports